<template>
	<div>
		<!-- Welcome message for owner -->
		<div v-if="isWelcome && currentUser.role === 'owner'" class="ReportMessage" data-panel="StayOpen" :aria-hidden="!showMessage">
			<div class="ReportMessage-message">
				<p>{{ $t('tripReport.welcomeOwner') }}</p>
				<p>{{ $t('tripReport.welcomeOwnerDesc') }}</p>
			</div>
			<div class="ReportMessage-actions">
				<button class="Button Button--hollow" @click="dismissMessage()">{{ $t('generic.dismiss') }}</button>
				<a :href="`${baseUrl}tripreport/edit/${this.tripReportId}?view=people`" class="Button">{{ $t('tripReport.addPeople') }}</a>
			</div>
		</div>
		<!-- Welcome message for non-owner -->
		<div
			v-if="isWelcome && (currentUser.role === 'participant' || currentUser.role === 'editor')"
			class="ReportMessage"
			data-panel="StayOpen"
			:aria-hidden="!showMessage"
		>
			<div class="ReportMessage-message">
				<p>{{ $t('tripReport.welcomeParticipant') }}</p>
				<p>{{ $t('tripReport.welcomeParticipantDesc') }}</p>
			</div>
			<div class="ReportMessage-actions">
				<button class="Button Button--hollow" @click="dismissMessage()">{{ $t('generic.dismiss') }}</button>
			</div>
		</div>
		<!-- Invited message -->
		<div v-if="currentUser.role === 'invited'" class="ReportMessage" data-panel="StayOpen" :aria-hidden="!showMessage">
			<div class="ReportMessage-message">
				<p>{{ $t('tripReport.userHasInvitedYou') }}</p>
			</div>
			<div class="ReportMessage-actions">
				<button class="Button Button--hollow" @click="declineInvitation()">{{ $t('manageChecklists.decline') }}</button>
				<button class="Button" @click="acceptInvitation()">{{ $t('tripReport.join') }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import CloButton from '@/base/CloButton/CloButton.vue';
import CloMessage from '@/layouts/CloMessage/CloMessage.vue';
export default {
	name: 'ReportMessage',
	components: {
		CloButton,
		CloMessage,
	},
	props: {
		tripReportId: Number,
		tripReportOwner: Object,
		currentUser: Object,
		isWelcome: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			baseUrl: window.baseUrl,
			csrf: window['_csrf'],
			csrf_header: window['_csrf_header'],
			tripManageApiBaseUrl: window.tripManageApiBaseUrl,
			showMessage: true,
		};
	},
	methods: {
		dismissMessage() {
			this.showMessage = false;
		},
		declineInvitation() {
			let url = this.tripManageApiBaseUrl + 'decline-invite/' + this.tripReportId;
			let headers = {};
			headers[this.csrf_header] = this.csrf;
			axios
				.delete(
					url,
					{
						headers: headers,
						withCredentials: true,
					},
					{}
				)
				.then((res) => {
					this.showMessage = false;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		acceptInvitation() {
			let url = this.tripManageApiBaseUrl + 'accept-invite/' + this.tripReportId;
			let headers = {};
			headers[this.csrf_header] = this.csrf;
			axios
				.patch(
					url,
					{},
					{
						headers: headers,
						withCredentials: true,
					}
				)
				.then((res) => {
					// passing welcome=true through to manage checklists, then report.
					window.location.href = `${baseUrl}tripreport/edit/${this.tripReportId}?view=checklists&welcome=true`;
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
};
</script>

<style lang="scss">
.ReportMessage {
	@include inset-md;
	background-color: $color-highlight;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: $space-sm;
	flex-wrap: wrap;
	&[aria-hidden='true'],
	&[hidden] {
		display: none;
	}
	p {
		@include text(3, loose);
		margin: 0;
		&:first-of-type {
			font-weight: bold;
		}
	}
	.Button {
		margin: 0;
		display: flex;
		align-items: center;
		@include text(3);
		@include inset-squish-md;
	}
	.ReportMessage-actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: $space-sm;
		flex-wrap: wrap;
		flex: 1 1 100%;
		@include breakpoint(medium) {
			flex: 0 1 auto;
		}
	}
}
</style>
